<template>
    <div id="ssoContent">
        <div class="ssoContentLeft">
            <div class="content_item">
                <img src="./images/msg.png">
                <div class="content_msg">
                    <div class="content_title">
                        即时资讯 精选评论
                    </div>
                    <div class="content_detail">
                        汇集全球热门金融资讯，快速了解市场行情。
                    </div>
                </div>
            </div>
            <div class="content_item">
                <img src="./images/master.png">
                <div class="content_msg">
                    <div class="content_title">
                        名师汇聚一堂
                    </div>
                    <div class="content_detail">
                        专家专业解读，在线答疑解惑。
                    </div>
                </div>
            </div>
            <div class="content_item">
                <img src="./images/econ.png">
                <div class="content_msg">
                    <div class="content_title">
                        一站式企业汇率风险管理平台
                    </div>
                    <div class="content_detail">
                        满足企业对汇率风险管理的多元化需求，实现企业高效、稳健、可持续的发展。
                    </div>
                </div>
            </div>
        </div>
        <div class="ssoContentRight">
            <slot></slot>
        </div>
    </div>
</template>
<script>
    module.exports = Vue.component('sso-content',{
        data:function() {
            return {
               
            }  
        },
    })  
</script>
<style lang="scss" scoped>
    #ssoContent{
        width:1120px;
        margin:0 auto;
        .ssoContentLeft{
            width:765px;
            display:inline-block;
            padding-top: 18px;
            .content_item{
                height: 66px;
                margin-bottom: 75px;
                vertical-align: text-top;
                img{
                    float: left;
                    margin-left:17px;
                    width: 66px;
                    height: 66px;
                }
                .content_msg{
                    display: inline-block;
                    margin-left: 34px;
                    height: 100%;
                    width: 600px;
                    .content_title{
                        letter-spacing: 2.36px;
                        font-size: 22px;
                        color: #fff;
                        margin-bottom: 12px;
                        line-height: 30px;
                    }
                    .content_detail{
                        line-height: 26px;
                        font-size: 14px;
                        letter-spacing: 0.88px;
                        color: #fff;
                        opacity: 0.8;
                    }
                }
            }

        }
        .ssoContentRight{
            display:inline-block;
            width:340px;
            float:right;
            margin-right: 15px;
            background: rgba(255, 255, 255, 0.7);
            border-radius:8px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/sso/components/content/content.vue